import { useAuth } from "@/context/AuthContext";
import { Settings as SettingsIcon } from "lucide-react";

export default function Settings() {
  const { user, currentWorkspace, currentRole } = useAuth();
  return (
    <div className="p-8 max-w-[1000px] mx-auto" data-testid="settings-page">
      <div className="mb-6">
        <div className="label-cap text-amber-500">// ACCOUNT &amp; WORKSPACE</div>
        <h1 className="font-heading text-3xl font-extrabold text-slate-100 mt-1 flex items-center gap-2">
          <SettingsIcon className="w-6 h-6 text-amber-400" /> Settings
        </h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="sc-card p-6">
          <div className="label-cap mb-3">Account</div>
          <Row k="Name" v={user?.name} />
          <Row k="Email" v={user?.email} />
        </div>
        <div className="sc-card p-6">
          <div className="label-cap mb-3">Workspace</div>
          <Row k="Name" v={currentWorkspace?.name} />
          <Row k="Your role" v={currentRole} />
          <Row k="Workspace ID" v={currentWorkspace?.id} mono />
        </div>
        <div className="sc-card p-6 md:col-span-2">
          <div className="label-cap mb-3">Risk Thresholds</div>
          <div className="text-sm text-slate-400">Default severity mapping: Critical = liquidated damages, indemnity clauses, delegated design responsibility. High = coating conflicts, AESS Level 3 requirements, non-standard inspection cost flow-downs.</div>
        </div>
      </div>
    </div>
  );
}
function Row({ k, v, mono }) {
  return (
    <div className="flex justify-between border-b border-slate-800 py-2 last:border-0">
      <span className="text-xs uppercase font-mono text-slate-500">{k}</span>
      <span className={`text-sm text-slate-100 ${mono ? "font-mono text-xs" : ""}`}>{v || "—"}</span>
    </div>
  );
}
